// extracted by mini-css-extract-plugin
module.exports = {"footerBox":"useTable_footerBox__1kcA7","table_bodys":"useTable_table_bodys__1AIPw"};